// Toothpillow Program page — JavaScript

document.addEventListener('DOMContentLoaded', () => {
  initSectionNav();
  initVideoPlayers();
  initStepsAccordion();
});


// ─── Section nav: scrollspy + click-to-scroll + mobile dropdown ───────────────
function initSectionNav() {
  const nav        = document.querySelector('.tp-program-nav');
  const sections   = document.querySelectorAll('.tp-program-section');
  const links      = document.querySelectorAll('.tp-program-nav__link');
  const toggle     = document.querySelector('.tp-program-nav__toggle');
  const toggleLabel = document.querySelector('.tp-program-nav__toggle-label');

  if (!nav || !sections.length || !links.length) return;

  // ── Click-to-scroll ─────────────────────────────────────────────────────────
  links.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      // Close mobile dropdown
      nav.classList.remove('is-open');
      toggle && (toggle.setAttribute('aria-expanded', 'false'));

      target.scrollIntoView({ behavior: 'smooth' });

      // Immediately mark as active on click (don't wait for IntersectionObserver)
      setActive(link);
    });
  });

  // ── Mobile dropdown toggle ───────────────────────────────────────────────────
  if (toggle) {
    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', e => {
      if (!nav.contains(e.target)) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // ── Scrollspy via IntersectionObserver ──────────────────────────────────────
  // rootMargin: fires when section top crosses ~10% from top of viewport
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const activeLink = document.querySelector(
        `.tp-program-nav__link[href="#${entry.target.id}"]`
      );
      if (activeLink) setActive(activeLink);
    });
  }, {
    rootMargin: '-10% 0px -60% 0px',
    threshold: 0
  });

  sections.forEach(section => observer.observe(section));

  // ── Helper: update active state ─────────────────────────────────────────────
  function setActive(activeLink) {
    links.forEach(l => l.classList.remove('is-active'));
    activeLink.classList.add('is-active');

    // Update mobile dropdown label
    if (toggleLabel) toggleLabel.textContent = activeLink.textContent.trim();
  }
}


// ─── Steps accordion: one-at-a-time toggle (matches questions__list pattern) ──
function initStepsAccordion() {
  const items = document.querySelectorAll('.tp-steps__item');
  if (!items.length) return;

  items.forEach((item) => {
    const btn = item.querySelector('.tp-steps__btn');
    if (!btn) return;

    btn.addEventListener('click', () => {
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';

      // Close all others
      items.forEach((other) => {
        const otherBtn = other.querySelector('.tp-steps__btn');
        if (otherBtn && otherBtn !== btn) {
          otherBtn.setAttribute('aria-expanded', 'false');
        }
      });

      btn.setAttribute('aria-expanded', String(!isExpanded));
    });
  });
}


// ─── Video players: thumbnail + click-to-play (matches home page pattern) ────
function initVideoPlayers() {
  const players = document.querySelectorAll('.tp-video-player');

  players.forEach(player => {
    const vimeoId = player.dataset.vimeoId;
    const thumb   = player.querySelector('.tp-video-player__thumb');
    const playBtn = player.querySelector('.tp-video-player__play');
    const iframe  = player.querySelector('.tp-video-player__iframe');

    if (!vimeoId || !iframe) return;

    const playVideo = () => {
      iframe.src = `https://player.vimeo.com/video/${vimeoId}?badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0&controls=1&autoplay=1`;
      player.classList.add('is-playing');
    };

    // Click on thumbnail or play button to start
    if (thumb) thumb.addEventListener('click', playVideo);
    if (playBtn) playBtn.addEventListener('click', playVideo);
  });
}
